export enum HeatingName {
  GAS = 'Chauffage au gaz',
  OIL = 'Chauffage au mazout'
}
